import { superFetch } from 'commons'

export const fetchCountries = () => {
  return superFetch({ url: `pays` })
}
